import { ChangeDetectorRef, Directive, Inject, Renderer2, AfterViewInit } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { ActivatedRoute } from '@angular/router'

@Directive({
  selector: 'mat-paginator[linPaginatorDefault]',
  standalone: false,
})
export class PaginatorDefaultDirective implements AfterViewInit {
  constructor(
    private paginator: MatPaginator,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {
    setTimeout(() => {
      // Ensure paginator is initialized
      const tabKey = this.getTabKey()
      const savedPageSize = localStorage.getItem(`linPaginatorPageSize_${tabKey}`)
      paginator.pageSize = savedPageSize ? +savedPageSize : 10
      paginator.pageSizeOptions = [5, 10, 25, 100]

      this.paginator.page.subscribe(() => {
        this.savePageSize(tabKey)
        this.updateTableWrapperHeight()
        this.cdr.detectChanges()
      })

      this.updateTableWrapperHeight()
      this.cdr.detectChanges()
    })
  }

  getTabKey(): string {
    return this.route.snapshot.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/')
  }

  savePageSize(tabKey: string): void {
    localStorage.setItem(`linPaginatorPageSize_${tabKey}`, this.paginator.pageSize.toString())
  }

  ngAfterViewInit(): void {
    this.updateTableWrapperHeight()
    setTimeout(() => {
      this.cdr.detectChanges()
    })
  }

  updateTableWrapperHeight(): void {
    const tableWrapper = (document.querySelector('.table-wrapper') as HTMLElement) || null

    if (tableWrapper) {
      const pageSize = this.paginator.pageSize

      if ([25, 100].includes(pageSize)) {
        tableWrapper.classList.remove('default-height')
        tableWrapper.classList.add('dynamic-height')
        tableWrapper.style.height = 'calc(80vh - 60px)'
      } else if ([5, 10].includes(pageSize)) {
        tableWrapper.classList.remove('dynamic-height')
        tableWrapper.classList.add('default-height')
        tableWrapper.style.height = '100%'
      }

      requestAnimationFrame(() => {
        this.cdr.detectChanges()
      })
    }
  }
}
